import React from 'react';
import Nav from '../components/Nav';
import style from './About.module.css'
import Submenu from './Submenu';
import Footer from '../components/Footer';
import { useRef , useState, useEffect } from "react";
import { Routes, Route, Link } from 'react-router-dom';
import './Recruit.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faPhone, faDesktop} from "@fortawesome/free-solid-svg-icons";
import './Support.css';
import './Solutionscv.css';

function Solutionscv (props){




  return(
    <div id="sb2">
        <div className='product'>
        <div className='inner1200'>
          <div className='titleWrap'>
              <h1 className='solutionTit'>AI SmartCallVision</h1>
              <p className='solutionText'>
              AI 스마트콜비전 v1.0 제품은 외부 민원전화에 대하여 수신/발신 시 전화기 액정 화면에서 전화 통화 관련 정보(최근 통화 시각, 평균통화시간, 기간별 수/발신 건수 등)를 IP Phone 액정에  표시해 줄 수 있는 솔루션 입니다. <br />
              또한 폭언/욕설/성희롱 경고 버튼을 사용하여 안내 멘트 송출 후 통화 종료를 하거나 장시간 통화 안내 멘트 제공 후 수동/자동 종료하는 기능을 제공 합니다.<br /><br />
              단일 시스템에서 스마트레터링, 폭언방지 안내 ARS, 전수/선택녹취, 컬러링, XML 기능을 통합 제공 할 수 있으며
              모바일 안심전화 발신 서비스를 옵션 사항으로 제공 할 수 있는 통합 민원전화 대응 솔루션 입니다.<br />
              녹취된 파일을 RX/TX 분리하여 STT로 추출하여 특이 민원 전화 내용을 추출 할 수 있으며 부서별, 기간별, 사업소별 주요 키워드를 추출하여 공공기관/ 지자체에 주요 정책에 반영하거나 민원전화 대응 부서에 가이드라인을 제공 할 수 있습니다. 

          </p>
            </div>
            <div className="scvImgWrap"><img src="/assets/scv_display.png" /></div>
        </div>
      </div>
      

    
      <div className='SLFuncWrap scvFuncWrap'>
          <div className='inner1200'>
            <h4 className='adTit'>AI 스마트콜비전의 <span>기능</span></h4>

            <ul>
                <li>
                  <div className="box">민원전화 담당 직원보호 효과</div>
                </li>
                <li>
                  <div className="box">민원 전화 대응 업무효율 향상</div>
                  
                </li>
                <li>
                  <div className="box">STT/TA를 활용한 민원전화 통화 분석</div>
                </li>
              </ul>

              <div className='table outIn'>
                <table>
                  <thead>
                    <tr>
                      <th>폭언방지/직원보호 효과</th>
                      <th>업무 효율 향상</th>
                      <th>STT/TA를 활용한 민원전화 통화분석</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                        산업안전보건법 강화 및 폭언 방지 음성안내 사전 고지를 통하여 폭언/욕설/ 성희롱 감소 효과<br />
                        폭언방지 안내를 통하여 민원전화 응대 직원 보호 효과<br />
                        폭언/욕설/성희롱 등 경고 멘트 송출을 통하여 직원 보호 효과

                        </p>
                      </td>
                      <td>
                        <p>
                        전화 액정에 악성민원전화 /최초 인입콜/ 평균통화시간/최근 통화 기록을 표시하여 민원전화 응대 직원의 업무 효율 극대화 <br />
                        행안부 권고 사항인 민원전화 20분 통화 후 종료 및 안내 멘트 송출을 통하여 민원전화 업무 직원의 업무 효율성 극대화<br />
                        폭언 방지 음성 안내 멘트를 통하여 민원전화 업무 직원의 업무 효율향상
                        폭언 비율 감소로 인해 전화 업무 담당자의 업무 스트레스 감소
  
                        </p>
                      </td>
                      <td>
                        <p>
                        통화내용을 RX/TX 화자 분리를 통하여 STT 활용도를 높이고 TA를 통한 각종 키워드를 추출 분석하여 민원전화 대응 가이드 자료로 활용 <br />
                        기간별,부서별,사업소별 주요 통화 내용 분석을 통한 민원인 주요 관심사를 이해하고 주요 정책에 반영 할 수 있는 데이터 자원 확보

                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
        </div>
          
          </div>
      </div>


      <div className='gs'>
        <div className='inner1200'>
        <h4 className='adTit'>AI 스마트콜비전의 <span>GS 인증</span></h4>
        <p className='adSubTit'>소프트웨어 품질인증서 입니다.
          </p>
        <div className='gsWrap'>
          <img src="/assets/gs_scv.png"/>

            <div className="gsTable">
              <h5>GS 인증번호: 25-0022</h5>
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>제품구성</th>
                    <th>식별번호</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>S/W Package</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781272</td>
                  </tr>
                  <tr>
                    <td>User License</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781273</td>
                  </tr>
                  <tr>
                    <td>IP License</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781274</td>
                  </tr>
                  <tr>
                    <td>IVR Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781275</td>
                  </tr>
                  <tr>
                    <td>REC Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781276</td>
                  </tr>
                  <tr>
                    <td>Coloring Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781277</td>
                  </tr>
                  <tr>
                    <td>XML Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781278</td>
                  </tr>
                  <tr>
                    <td>STT Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781279</td>
                  </tr>
                  <tr>
                    <td>STT Player Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781280</td>
                  </tr>
                  <tr>
                    <td>STT RX/TX Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781266</td>
                  </tr>
                  <tr>
                    <td>STT User License</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781267</td>
                  </tr>
                  <tr>
                    <td>TA Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781268</td>
                  </tr>
                  <tr>
                    <td>TA License</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781269</td>
                  </tr>
                  <tr>
                    <td>MS Module</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781270</td>
                  </tr>
                  <tr>
                    <td>PBX I/F License</td>
                    <td>아우룸 스마트콜비전 v1.0</td>
                    <td>26781271</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    
  </div>
  
  )
}


export default Solutionscv;